import loadComponents from './components';
import loadBlocks from './blocks';
import loadCommands from './commands';
import loadTraits from './traits';
import loadPanels from './panels';
import loadAssets from './assets';

import loadStepConfig from './steps';
import loadResourcesConfig from './resources';
import loadCodeEditorConfig from './CodeEditor';

export default async (editor, opts = {}) => {
    const options = {
        ...{
            i18n: {},
            // default options
            step_id: null,
            isStep: false,
            optionsStringSeparator: "::",
            template_id: null,
            order_step: 0,
            storage_name: 'S-STEPS',
            storage_alternative: 'remote',
            host_api: "https://eu1-api.leadgrease.com",
            questions_by_step: [],
            components: {
                gender: {
                    name: 'gender',
                    man: {
                        value: 'H',
                        label: 'Sr',
                    },
                    woman: {
                        value: 'W',
                        label: 'Sra'
                    }
                }
            },
            resources: [
                {
                    type: 'font',
                    active: true,
                    name: 'Roboto',
                    value: 'Roboto, Arial, sans-serif',
                    external_resource: false,
                    position: 'head',
                    url: ''
                },
            ],
        }, ...opts
    };


    editor.Config.canvasCss += /*css*/`
        .list-toggle{
            display: flex;
            list-style: none;
            padding: 0;
            margin:0;
        }
        .list-toggle .item{
            margin: 0 0.3rem;
            display: flex !important;
            align-items: center;
            justify-content: center;
            min-height: 1.2rem !important;
        }
        .list-toggle .item .dropdown-toggle::after{
            content:none;
        }
        .list-toggle .item svg{
            fill:white;
        }
        .list-toggle .item svg path{
            fill:white;
        }
        .list-toggle .item svg g{
            fill:white;
        }
        .list-toggle .dropdown-menu{
            background: transparent;
            border: none;
            min-width: 14rem;
            display:flex;
        }

        .gjs-dashed .form-row{
            min-height: 1.5rem !important;
        }

        .gjs-dashed .invalid-feedback{
            display:block !important;
        }

        .gjs-dashed .form-group{
            padding:5px !important;
        }
    `
    loadTraits(editor, options);
    // Add commands
    loadCommands(editor, options);

    loadStepConfig(editor, options);
    loadResourcesConfig(editor, options);
    loadCodeEditorConfig(editor, options);

    // Add panels
    await loadPanels(editor, options);
    // Add components
    loadComponents(editor, options);

    // Add blocks
    loadBlocks(editor, options);


    loadAssets(editor, options);
    // Load i18n files

    editor.I18n && editor.I18n.addMessages({
        // en,
        ...options.i18n,
    });

    editor.on('modal:open', () => {
        let md = editor.Modal;
        let gjs_mdl_dialog = document.querySelector('.gjs-mdl-dialog');
        let gjs_mdl_container = document.querySelector('.gjs-mdl-container');
        gjs_mdl_container.addEventListener('click', function (e) {
            if (!gjs_mdl_dialog.contains(e.target)) {
                md.open();
            }
        });
    });

    editor.on('component:create', (component) => {
        let attr = component.getAttributes();
        if (attr["data-custom-name"]) {
            component.set({
                'custom-name': attr["data-custom-name"]
            })
        } else {
            attr = {
                ...attr,
                'data-custom-name': component.get('custom-name')
            }
            component.setAttributes(attr);
            // console.log(attr);
        }
    });

    editor.on('component:update:custom-name', (component) => {
        let attr = component.getAttributes();
        if (attr["data-custom-name"] != component.get('custom-name')) {
            attr = {
                ...attr,
                'data-custom-name': component.get('custom-name')
            }
            component.setAttributes(attr);
            // console.log(attr);
        }
    });

};